<template>
  <div class="dropdown inline-block relative">
    <button class="ml-8 inline-flex items-center">
      <span class="mr-1"><img class="w-8" :src="`${getFlag($i18n.locale)}.svg`"/></span>
      <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
    </button>
    <ul class="border rounded-sm dropdown-menu absolute hidden bg-white pt-2 px-2 z-50" style="margin-left: 1.35rem;">
      <li class="mb-2 cursor-pointer" v-for="locale in $i18n.availableLocales" :key="`locale-${locale}`" @click="setLocale(locale)">
        <img class="w-7" :src="`${getFlag(locale)}.svg`"/>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'Switcher',
})
export default class Switcher extends Vue {
  setLocale(locale: string) {
    this.$i18n.locale = locale
    localStorage.setItem('lang', this.$i18n.locale);
    let url = new URL(window.location.href);
    url.searchParams.set('lg', locale);
    window.location.href = url.toString();
  }
  getFlag(locale: string) {
    return locale.split('-')[0] || 'sl'
  }
}
</script>
